import React from 'react';

import { defineKey } from '@ha/intl';
import { LinkList } from './LinkList';
import { tenantsColumnData } from '../constants';

export interface Props {
  rel: string;
}

const TenantsLinks: React.FC<Props> = ({ rel }) => {
  return (
    <LinkList
      rel={rel}
      title={defineKey('Tenants')}
      links={tenantsColumnData}
    />
  );
};

export { TenantsLinks };
